export default __webpack_public_path__ + "static/media/my-assets.97c44347.png";